<template>
<div class="spinner"></div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>